import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "../../style/lauout/main.header";
import { useEffect, useState } from "react";

const MainHeader = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로를 감지하는 훅

  // 햄버거 메뉴의 열림/닫힘 상태를 관리
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 페이지 경로가 변경될 때마다 햄버거 메뉴 상태 초기화
  useEffect(() => {
    setIsMenuOpen(false); // 경로 변경 시 메뉴 닫기
  }, [location]); // location이 변경될 때마다 실행

  return (
    <Container>
      <div className="inner">
        <div
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/");
          }}
        >
          <span className="icon-box">
            <img src="../assets/logo.png" alt="" />
          </span>
          <span className="img-box">
            <img src="../assets/logo_txt.png" alt="" />
          </span>
        </div>

        <div className="sub">
          <span
            onClick={() => {
              navigate("/join");
            }}
          >
            서비스 신청
          </span>
          <span className="hr"></span>
          <span
            onClick={() => {
              navigate("/login");
            }}
          >
            로그인
          </span>
        </div>
        {/* 햄버거 메뉴 버튼 (모바일에서만 보이게 처리) */}
        <div
          className={`hamburger-menu ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* 모바일 메뉴 토글 */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <div className="inner">
              <span onClick={() => navigate("/join")}>회원가입</span>
              <span onClick={() => navigate("/login")}>로그인</span>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default MainHeader;
